import React, { Suspense } from 'react'
import { AuthRoute, Switch, Route, NotFound, useLocation, Redirect } from '@fs/zion-router'
import ErrorBoundary from '@fs/zion-error-boundary'
import { BrightspotRouting } from '@fs/zion-cms'
import { useFeatureFlag } from '@fs/zion-flags'
import HomePageSkeleton from './components/HomePageSkeleton'
import NavArrows from './components/NavArrows'
import PaddedLayoutBand from './components/shared/PaddedLayoutBand'

// Dynamically load components to reduce bundle size
// https://reactjs.org/docs/react-api.html#reactlazy

// const GettingStartedCards = React.lazy(() => import('./components/getting-started-cards/GettingStartedCards'))
const GettingStartedCardsV2 = React.lazy(() => import('./components/getting-started-cards/GettingStartedCards'))
const CreateFamilyTree = React.lazy(() => import('./components/create-family-tree/CreateFamilyTree'))
const HistoricalRecords = React.lazy(() => import('./components/historical-records/HistoricalRecords'))
const SaveFamilyMemories = React.lazy(() => import('./components/save-family-memories/SaveFamilyMemories'))
const TryIndexing = React.lazy(() => import('./components/try-indexing/TryIndexing'))
const HaveFun = React.lazy(() => import('./components/have-fun/HaveFun'))
const OrdinancesReady = React.lazy(() => import('./components/ordinances-ready/OrdinancesReady'))
const HaveSomeoneInMind = React.lazy(() => import('./components/have-someone-in-mind/HaveInMind'))
const AncestorTips = React.lazy(() => import('./components/ancestor-tips/AncestorTips'))
const MakeDiscoveries = React.lazy(() => import('./components/make-discoveries/MakeDiscoveries'))

function App() {
  const { pathname } = useLocation()
  const gettingStartedFlag = useFeatureFlag('help_cms_gettingstarted')
  return (
    <ErrorBoundary>
      <Suspense fallback={<HomePageSkeleton />}>
        <Switch>
          {gettingStartedFlag?.isOn && (
            <Route
              path="/gettingstarted"
              exact
              render={() => {
                return <BrightspotRouting site="gettingstarted" />
              }}
            />
          )}
          {!gettingStartedFlag?.isOn && (
            <Route path="/gettingstarted" exact>
              <GettingStartedCardsV2 />
            </Route>
          )}
          <Route
            path="/gettingstarted/get-started"
            exact
            render={() => {
              return <BrightspotRouting site="gettingstarted" />
            }}
          />
          <AuthRoute exact path="/gettingstarted/ordinances-ready" component={OrdinancesReady} />
          <AuthRoute exact path="/gettingstarted/have-someone-in-mind" component={HaveSomeoneInMind} />
          <AuthRoute exact path="/gettingstarted/ancestor-search-tips" component={AncestorTips} />
          <Route exact path="/gettingstarted/make-discoveries" component={MakeDiscoveries} />
          <Route exact path="/gettingstarted/save-family-memories" component={SaveFamilyMemories} requirePersonalData />
          <Route exact path="/gettingstarted/create-family-tree" component={CreateFamilyTree} />
          {/* Backward-compatible redirect of old route to new route, can possibly be removed in the future */}
          <Redirect from="/gettingstarted/historical-records" to="/gettingstarted/find-ancestors" />
          <Route exact path="/gettingstarted/find-ancestors" component={HistoricalRecords} />
          {/* Backward-compatible redirect of old route to new route, can possibly be removed in the future */}
          <Redirect from="/gettingstarted/try-indexing" to="/gettingstarted/get-involved" />
          <Route exact path="/gettingstarted/get-involved" component={TryIndexing} requirePersonalData />
          {/* Backward-compatible redirect of old route to new route, can possibly be removed in the future */}
          <Redirect from="/gettingstarted/have-fun" to="/gettingstarted/family-history-fun" />
          <Route exact path="/gettingstarted/family-history-fun" component={HaveFun} requirePersonalData />
          <Route component={NotFound} />
        </Switch>

        {pathname === '/gettingstarted' ? null : (
          <PaddedLayoutBand>
            <NavArrows />
          </PaddedLayoutBand>
        )}
      </Suspense>
    </ErrorBoundary>
  )
}
export default App
